import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-crea-nuovo-profilo',
  templateUrl: './crea-nuovo-profilo.component.html',
  styleUrls: ['./crea-nuovo-profilo.component.css']
})
export class CreaNuovoProfiloComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
